import { styled, Text } from 'tamagui';

import { type } from '@/constants/tokens';

// One Tamagui Text per type role in constants/tokens.ts, so a call site picks a
// ROLE (<PSText.H2>About</PSText.H2>) instead of a size + weight + line height.
// Every Text prop still passes through, and a role's own styles can be
// overridden inline where a call site genuinely differs.
//
// There is no bare <PSText>: a role-less text is the drift this replaces.
// Colour isn't part of a role — pass it (see the note in tokens.ts).
// `Tags` is the style sheet's role name (every PSBadge), not a plural.
const PSText = {
  Title: styled(Text, { name: 'PSTextTitle', ...type.title }),
  SubTitle: styled(Text, { name: 'PSTextSubTitle', ...type.subTitle }),
  H1: styled(Text, { name: 'PSTextH1', ...type.h1 }),
  H2: styled(Text, { name: 'PSTextH2', ...type.h2 }),
  H3: styled(Text, { name: 'PSTextH3', ...type.h3 }),
  Body1: styled(Text, { name: 'PSTextBody1', ...type.body1 }),
  Body2: styled(Text, { name: 'PSTextBody2', ...type.body2 }),
  Body3: styled(Text, { name: 'PSTextBody3', ...type.body3 }),
  Body4: styled(Text, { name: 'PSTextBody4', ...type.body4 }),
  Tags: styled(Text, { name: 'PSTextTags', ...type.tags }),
};

export default PSText;
